import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    View,
    Text,
    StyleSheet,
    Linking,
    TouchableOpacity
} from 'react-native'

import { dateRangeFormat } from '../../lib/index'
import STYLES from '../../constants/styles'

export default class ErrorCard extends Component {
    static propTypes = {
        cardStyle: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]),
        offsetKeyDate: PropTypes.object
    }

    supportLink() {
        Linking.openURL('mailto://support@meetcarrot.xyz?Subject=Problems%20with%20Merchant%20Dashboard')
    }

    render() {
        let { cardStyle, offsetKeyDate } = this.props

        return (
            <View style={[styles.container, cardStyle]}>
                {offsetKeyDate && <Text style={styles.cardText}>
                    Error Retreving Transactions for {'\n'}
                    {dateRangeFormat(offsetKeyDate)}
                </Text>}
                {!offsetKeyDate && <Text style={styles.cardText}>
                    Error Retreving Transactions
                </Text>}
                <Text style={[styles.cardText, { marginTop: 20 }]}>
                    Please Try Again Later.
                </Text>
                <Text style={[styles.cardText, { marginTop: 20 }]}>
                    Or you can email us at
                </Text>
                <TouchableOpacity onPress={this.supportLink.bind(this)}>
                    <Text style={styles.cardText}>
                        support@meetcarrot.xyz
                    </Text>
                </TouchableOpacity>
            </View>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: STYLES.ERROR_CARD_BACKGROUND_COLOR
        , borderWidth: 2
        , borderColor: STYLES.ERROR_CARD_BORDER_COLOR
        , borderRadius: 20
        , flexDirection: 'column'
        , justifyContent: 'center'
        , alignItems: 'center'
        , shadowColor: STYLES.SHADOW_COLOR
        , shadowRadius: 40
        , shadowOffset: { width: 4, height: 6 }
    },
    cardText: {
        fontSize: 16
        , fontWeight: 'bold'
        , textAlign: 'center'
        , color: STYLES.SECONDARY_TEXT_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/components/cardError/index.js